<template>
  <div>
    <loading-spinner v-if="!user" />
    <app-header v-if="user" :title="user.id ? editTitle : newTitle">
      <template #col-right>
        <b-button variant="primary" class="mr-1" @click="save()">
          <span v-label-key="'SAVE_CHANGES'">Save Changes</span>
        </b-button>
        <cancel-button class="ml-2" />
      </template>
    </app-header>
    <b-container v-if="user">
      <b-row>
        <b-col md="4">
          <errors v-if="errors.length" :errors="errors" />
          <b-form ref="editorForm">
            <b-form-group
              :label="`${getLabel('EDIT_USER_FIRST_NAME')} *`"
              :description="getLabel('EDIT_USER_FIRST_NAME_DESCRIPTION')"
            >
              <b-form-input
                v-model="user.first_name"
                type="text"
                class="form-control"
                required
              />
            </b-form-group>

            <b-form-group
              :label="`${getLabel('EDIT_USER_LAST_NAME')} *`"
              :description="getLabel('EDIT_USER_LAST_NAME_DESCRIPTION')"
            >
              <b-form-input
                v-model="user.last_name"
                type="text"
                class="form-control"
                required
              />
            </b-form-group>

            <b-form-group
              :label="`${getLabel('EMAIL')} *`"
              :description="getLabel('EDIT_USER_EMAIL_DESCRIPTION')"
            >
              <b-form-input
                v-model="user.email"
                type="email"
                class="form-control"
                required
              />
            </b-form-group>

            <b-form-group
              v-if="user.id"
              :label="getLabel('PASSWORD')"
              :description="getLabel('EDIT_USER_PASSWORD_DESCRIPTION')"
            >
              <b-form-input
                v-model="user.password"
                type="password"
                class="form-control"
              />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="8" />
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import $auth from '@/services/auth';
import CancelButton from '@/components/CancelButton';
import LoadingSpinner from '@/components/LoadingSpinner';
import Errors from '@/components/Errors';
import AppHeader from '@/components/AppHeader';
import { mapGetters } from 'vuex';

export default {
  components: {
    CancelButton,
    LoadingSpinner,
    Errors,
    AppHeader,
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
      getReplaceLabel: 'getReplaceLabel',
    }),
    editTitle() {
      return this.getReplaceLabel('EDIT_ITEM_NAME', {
        '{NAME}': this.user.email,
      });
    },
    newTitle() {
      return this.getReplaceLabel('NEW_ITEM_NAME', {
        '{NAME}': this.getLabel('USER'),
      });
    },
  },
  data() {
    return {
      orgname: null,
      user: null,
      auth: $auth,
      errors: [],
      emailDistributor: '',
    };
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      if (this.$route.query.id) {
        $api
          .get(`/v1/dashboard/dashboardusers/${this.$route.query.id}`)
          .then(user => {
            this.user = user;
            this.orgname =
              this.user.distributor_name ||
              this.user.subdistributor_name ||
              this.user.chain_name ||
              'GoKaizen';
          });
      } else {
        this.user = this.$route.query;
        this.orgname = this.$route.query.orgname;
      }
    },
    validateForm() {
      this.errors = [];

      if (!this.user.first_name) {
        this.errors.push(
          this.getLabel('FORM_ERROR_FIRST_NAME_REQUIRED') ||
            'The first name field is required.'
        );
      }

      if (!this.user.last_name) {
        this.errors.push(
          this.getLabel('FORM_ERROR_LAST_NAME_REQUIRED') ||
            'The last name field is required.'
        );
      }

      if (!this.user.email) {
        this.errors.push(
          this.getLabel('FORM_ERROR_EMAIL_REQUIRED') ||
            'The email field is required.'
        );
      }
    },

    save() {
      if (!this.$refs.editorForm.checkValidity()) {
        this.$refs.editorForm.reportValidity();
        this.validateForm();
        return;
      }

      this.errors = [];

      if (this.user.id) {
        $api
          .put(`/v1/dashboard/dashboardusers/${this.user.id}`, this.user)
          .then(() => {
            this.$router.push({
              name: 'user-detail',
              params: this.user,
            });
          });
      } else {
        $api.post('/v1/dashboard/dashboardusers', this.user).then(user => {
          this.$router.push({
            name: 'user-detail',
            params: user,
          });
        });
      }
    },
  },
};
</script>
